/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Annuler"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Vous avez obtenu une justification commerciale pour accéder aux données des clients."
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Votre activité de téléchargement sera enregistrée et suivie à des fins de conformité en matière de sécurité."
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Souhaitez-vous poursuivre?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "En téléchargeant, vous reconnaissez que :"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
